import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Section } from './Shared';
import { DnaHelix, Mandala, TreeOfLife } from './BioDecor';
import { bonuses, tomes } from '../data/kitContents';
const accentStyles: Record<'blue' | 'green' | 'gold', {
  badge: string;
  title: string;
  check: string;
}> = {
  blue: {
    badge: 'bg-brand-blue text-brand-goldLight',
    title: 'text-brand-blue',
    check: 'text-brand-blueMid'
  },
  green: {
    badge: 'bg-brand-green text-brand-goldLight',
    title: 'text-brand-green',
    check: 'text-brand-greenMid'
  },
  gold: {
    badge: 'bg-brand-goldDark text-brand-goldLight',
    title: 'text-brand-goldDark',
    check: 'text-brand-gold'
  }
};
export function PackContents() {
  return <Section id="contenido" className="relative" data-id="element-233" data-mp="92lvwhnmg8kc">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-234" data-mp="91avmrtdxixz">
        <TreeOfLife className="absolute right-[3%] top-8 h-40 w-24 text-brand-sageMist" data-id="element-235" data-mp="wrdfikn5bili" />
        <DnaHelix className="absolute left-[2%] top-1/2 h-48 w-20 text-brand-blueMist" data-id="element-236" data-mp="11kpue320wb12" />
      </div>

      <div className="mb-4 text-center" data-id="element-237" data-mp="3p7nyqun7ba2q">
        <p className="mb-2 text-sm font-bold uppercase tracking-[.18em] text-brand-goldDark" data-id="element-238" data-mp="3k8jr48fxdkei">✨ Todos los niveles</p>
        <h2 className="font-display text-3xl font-bold text-brand-blue md:text-5xl" data-id="element-239" data-mp="2s1tgq0wlsgc">
          3 Tomos Principales + 5 Bonus Estratégicos
        </h2>
        <div className="mt-4 flex flex-wrap justify-center gap-3 text-sm font-semibold text-brand-textLight md:text-base" data-id="element-240" data-mp="3u4eefgv3g3nm">
          <span className="rounded-full border border-brand-blue/20 bg-white px-4 py-1.5" data-id="element-241" data-mp="6teyixw69rm7">📚 3 Tomos + 5 Bonus</span>
          <span className="rounded-full border border-brand-gold/40 bg-white px-4 py-1.5" data-id="element-242" data-mp="lr7e1q1pyg0e">📖 +150 páginas</span>
        </div>
      </div>

      <p className="mx-auto mb-10 mt-6 max-w-2xl text-center text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-243" data-mp="gs47g163c1qb">
        Ya sea que estés comenzando con Biodescodificación o que ya atiendas pacientes y quieras hacerlo con más
        criterio, seguridad y estructura profesional,{' '}
        <strong className="text-brand-greenMid" data-id="element-244" data-mp="388o3btb4keie">el Kit Maestro fue creado para vos</strong>.
      </p>

      <div className="mx-auto grid max-w-6xl gap-6 lg:grid-cols-3" data-id="element-245" data-mp="3c96x3swkvun8">
        {tomes.map(tome => {
        const accent = accentStyles[tome.accent];
        return <article key={tome.label} className="paper-panel flex h-full flex-col rounded-3xl p-6 md:p-7" data-id="element-246" data-mp="3m74jeauvnhd7">
              <div className="mb-4 flex gap-4" data-id="element-247" data-mp="3r4wefdqtjjlm">
                <img src={tome.cover} alt={tome.coverAlt} loading="lazy" draggable={false} className="h-[150px] w-[106px] shrink-0 rounded-lg object-cover object-top shadow-[0_10px_22px_rgba(8,32,60,.2)] ring-1 ring-brand-blue/15" data-id="element-248" data-mp="3r44pglrq8k4b" />
                <div className="min-w-0" data-id="element-249" data-mp="drudernv9s05">
                  <span className={`inline-flex items-center gap-2 rounded-lg px-3 py-1.5 text-[11px] font-bold tracking-[.18em] ring-1 ring-brand-gold/40 ${accent.badge}`} data-id="element-250" data-mp="doycqvkmwp80">
                    <span aria-hidden="true" data-id="element-251" data-mp="235tygu8utb1b">{tome.emoji}</span>
                    {tome.label}
                  </span>
                  <h3 className={`mt-3 font-serif text-lg font-bold leading-tight md:text-xl ${accent.title}`} data-id="element-252" data-mp="1t9qtzhqj50b7">
                    {tome.title}
                  </h3>
                  <p className="mt-1.5 text-xs italic leading-snug text-brand-muted" data-id="element-253" data-mp="1od0jd9xhuwx6">{tome.subtitle}</p>
                </div>
              </div>
              <div className="leaf-rule mb-4" aria-hidden="true" data-id="element-254" data-mp="2gzbfo8e2ibo6" />
              <ul className="space-y-2.5 text-sm leading-snug text-brand-text" data-id="element-255" data-mp="2h1xpkeofl39k">
                {tome.features.map(feature => <li key={feature} className="flex gap-2.5" data-id="element-256" data-mp="27ajssenv6hk4">
                    <span className={`font-bold ${accent.check}`} data-id="element-257" data-mp="277xkgct5fy0u">✓</span>
                    <span data-id="element-258" data-mp="34qgv4mg3j1xy">{feature}</span>
                  </li>)}
              </ul>
            </article>;
      })}
      </div>

      <div className="mb-6 mt-14 text-center" data-id="element-259" data-mp="2kfwh2o8yzraz">
        <h3 className="font-serif text-xl font-bold text-brand-blue md:text-2xl" data-id="element-260" data-mp="2kf4n1hv0u1mt">
          🎁 5 BONUS ESTRATÉGICOS — <span className="text-brand-goldDark" data-id="element-261" data-mp="2pdfwvslbgc51">SIEMPRE INCLUIDOS</span>
        </h3>
      </div>

      <div className="mx-auto grid max-w-6xl gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-262" data-mp="2akcoobtm7aqz">
        {bonuses.map(bonus => <article key={bonus.number} className="flex gap-4 rounded-2xl border border-brand-blue/15 bg-brand-blueMist/50 p-4" data-id="element-263" data-mp="336xev8yctgsy">
            <img src={bonus.cover} alt={bonus.coverAlt} loading="lazy" draggable={false} className="h-[124px] w-[88px] shrink-0 rounded-lg object-cover object-top shadow-[0_8px_18px_rgba(8,32,60,.18)] ring-1 ring-brand-blue/15" data-id="element-264" data-mp="385h3xi88v8pj" />
            <div className="flex min-w-0 flex-col" data-id="element-265" data-mp="3m4gremk0thk4">
              <div className="mb-2 flex flex-wrap items-center gap-2" data-id="element-266" data-mp="3qwrqxoaun1c5">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-blue px-2.5 py-1 text-[10px] font-bold tracking-wide text-brand-goldLight" data-id="element-267" data-mp="1fhj34yp7qne3">
                  <GiftIcon className="h-3 w-3" data-id="element-268" data-mp="1ai66jm8ji1yb" />
                  BONUS {bonus.number}
                </span>
                <span className="text-[11px] font-semibold text-brand-goldDark" data-id="element-269" data-mp="1p9f2se6y6lkf">{bonus.pages}</span>
              </div>
              <p className="text-[15px] font-bold leading-tight text-brand-blue" data-id="element-270" data-mp="winc1w8nip4h">{bonus.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-brand-textLight" data-id="element-271" data-mp="rjk5269428tv">{bonus.description}</p>
            </div>
          </article>)}
      </div>

      <div className="relative mt-10 text-center" data-id="element-272" data-mp="15kwlsjw3iegt">
        <Mandala aria-hidden="true" className="pointer-events-none absolute -top-6 left-1/2 h-10 w-10 -translate-x-1/2 text-brand-amber/40" data-id="element-273" data-mp="11hzv05wejc1s" />
        <p className="inline-block rounded-full border border-brand-gold/60 bg-white px-5 py-3 text-sm font-medium text-brand-text" data-id="element-274" data-mp="2gx77y7gc3cca">
          Todo el valor de los bonus{' '}
          <span className="font-bold text-brand-greenMid" data-id="element-275" data-mp="19msjstsrlb1c">incluido con tu Kit Maestro de Biodescodificación</span>
        </p>
      </div>
    </Section>;
}